import tipoUsuario from './tipo-usuario';

const regras = {
  liberarSolicitacoes(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && (ctx.usuario.permissoes.liberarSolWEB1 ||
      ctx.usuario.permissoes.liberarSolWEB2);
  },
  liberarPedidosCompra(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.liberarPedidoCompra && ctx.configuracao.utilizarLiberacaoPedidoCoordenador;
  },
  aprovarPesquisaPreco(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.aprovarPesquisaPreco && ctx.configuracao.utilizarAprovacaoPesquisaPreco;
  },
  matricularAlunos(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solCursoEventoMatricular;
  },
  doacoesRealizadas(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solCursoEventoServico && ctx.configuracao.utilizarDoacao;
  },
  eventosRealizados(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solCursoEventoServico && ctx.configuracao.utilizarEvento;
  },
  infoProjeto(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && (
      (ctx.solBolsa) ||
      (ctx.solCompras) ||
      (ctx.solPagamentoPessoaFisica) ||
      (ctx.solPagamentoPessoaJuridica) ||
      (ctx.solPagamentoPessoaFisicaRateio) ||
      (ctx.solPagamentoPessoaJuridicaRateio) ||
      (ctx.solReembolso) ||
      (ctx.solFaturamento) ||
      (ctx.solReembolsoTerceiro) ||
      (ctx.solAdiantamento) ||
      (ctx.relatorios)
    );
  },
  terminoProjeto(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador;
  },
  mensagemSistema(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && (
      (ctx.solBolsa) ||
      (ctx.solCompras) ||
      (ctx.solCursoEventoServico) ||
      (ctx.solTransferencia) ||
      (ctx.solPagamentoPessoaFisica) ||
      (ctx.solPagamentoPessoaJuridica) ||
      (ctx.solReembolso) ||
      (ctx.solFaturamento) ||
      (ctx.solReembolsoTerceiro) ||
      (ctx.solAdiantamento)
    ) && !ctx.configuracao.naoUtilizarMensageria;
  },
  solicitacoes(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && (
      (ctx.configuracao.solCompras && ctx.usuario.permissoes.solCompras) ||
      ((ctx.configuracao.solPagamentoPessoaFisica || ctx.configuracao.solPagamentoPessoaJuridica) &&
        (ctx.usuario.permissoes.solPagamentoPessoaFisica || ctx.usuario.permissoes.solPagamentoPessoaJuridica) && !ctx.configuracao.utilizarRateioSolicitacoes) ||
      (ctx.configuracao.solPagamentoPessoaFisica && ctx.usuario.permissoes.solPagamentoPessoaFisica && !ctx.configuracao.utilizarRateioSolicitacoes) ||
      (ctx.configuracao.solPagamentoPessoaJuridica && ctx.usuario.permissoes.solPagamentoPessoaJuridica && !ctx.configuracao.utilizarRateioSolicitacoes) ||
      ((ctx.configuracao.solPagamentoPessoaFisica || ctx.configuracao.solPagamentoPessoaJuridica) &&
        (ctx.usuario.permissoes.solPagamentoPessoaFisica || ctx.usuario.permissoes.solPagamentoPessoaJuridica) && ctx.configuracao.utilizarRateioSolicitacoes) ||
      (ctx.configuracao.solPagamentoPessoaFisica && ctx.usuario.permissoes.solPagamentoPessoaFisica && ctx.configuracao.utilizarRateioSolicitacoes) ||
      (ctx.configuracao.solPagamentoPessoaJuridica && ctx.usuario.permissoes.solPagamentoPessoaJuridica && ctx.configuracao.utilizarRateioSolicitacoes) ||
      (ctx.configuracao.solReembolso && ctx.usuario.permissoes.solReembolso) ||
      (ctx.configuracao.solFaturamento && ctx.usuario.permissoes.solFaturamento) ||
      (ctx.configuracao.solFatPFEstrangeiro && ctx.usuario.permissoes.solFaturamento) ||
      (ctx.configuracao.solFatPJEstrangeiro && ctx.usuario.permissoes.solFaturamento) ||
      (ctx.configuracao.solFaturamentoMc && ctx.usuario.permissoes.solFaturamentoMc) ||
      (ctx.configuracao.solReembolsoTerceiro && ctx.usuario.permissoes.solReembolsoTerceiro) ||
      (ctx.configuracao.solAdiantamento && ctx.usuario.permissoes.solAdiantamento) ||
      (ctx.configuracao.solBolsa && ctx.usuario.permissoes.solBolsa) ||
      (ctx.usuario.permissoes.solCursoEventoServico) ||
      (ctx.usuario.permissoes.solTransferencia) ||
      (ctx.usuario.permissoes.solCancelamentoContrato) ||
      (ctx.usuario.permissoes.solContratacaoPessoal)
    );
  },
  solCompras(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.solCompras && ctx.usuario.permissoes.solCompras;
  },
  solPagamento(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador &&
      (ctx.configuracao.solPagamentoPessoaFisica || ctx.configuracao.solPagamentoPessoaJuridica) &&
      (ctx.usuario.permissoes.solPagamentoPessoaFisica || ctx.usuario.permissoes.solPagamentoPessoaJuridica) && !ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoPessoaFisica(ctx) {
    return ctx.configuracao.solPagamentoPessoaFisica && ctx.usuario.permissoes.solPagamentoPessoaFisica && !ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoPessoaJuridica(ctx) {
    return ctx.configuracao.solPagamentoPessoaJuridica && ctx.usuario.permissoes.solPagamentoPessoaJuridica && !ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoEstrangeiroPF(ctx) {
    return ctx.configuracao.solPagamentoPessoaFisica && ctx.configuracao.solPgtoPFEstrangeiro && ctx.usuario.permissoes.solPagamentoPessoaFisica && !ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoEstrangeiroPJ(ctx) {
    return ctx.configuracao.solPagamentoPessoaJuridica && ctx.configuracao.solPgtoPJEstrangeiro && ctx.usuario.permissoes.solPagamentoPessoaJuridica && !ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoRateio(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador &&
      (ctx.configuracao.solPagamentoPessoaFisica || ctx.configuracao.solPagamentoPessoaJuridica) &&
      (ctx.usuario.permissoes.solPagamentoPessoaFisica || ctx.usuario.permissoes.solPagamentoPessoaJuridica) && ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoPessoaFisicaRateio(ctx) {
    return ctx.configuracao.solPagamentoPessoaFisica && ctx.usuario.permissoes.solPagamentoPessoaFisica && ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solPagamentoPessoaJuridicaRateio(ctx) {
    return ctx.configuracao.solPagamentoPessoaJuridica && ctx.usuario.permissoes.solPagamentoPessoaJuridica && ctx.configuracao.utilizarRateioSolicitacoes;
  },
  solReembolso(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.solReembolso && ctx.usuario.permissoes.solReembolso;
  },
  solReembolsoEstrangeiro(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador
      && ctx.configuracao.solReembolso
      && ctx.usuario.permissoes.solReembolso
      && ctx.configuracao.solDiariaEstrangeiro;
  },
  solFaturamento(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador &&
      (ctx.configuracao.solFaturamento || ctx.configuracao.solFaturamentoMc ||
        ctx.configuracao.solFatPFEstrangeiro || ctx.configuracao.solFatPJEstrangeiro) &&
      (ctx.usuario.permissoes.solFaturamento || ctx.usuario.permissoes.solFaturamentoMc);
  },
  solFaturamentoPFPJ(ctx) {
    return ctx.configuracao.solFaturamento && ctx.usuario.permissoes.solFaturamento;
  },
  solFaturamentoMC(ctx) {
    return ctx.configuracao.solFaturamentoMc && ctx.usuario.permissoes.solFaturamentoMc;
  },
  solFaturamentoEstrangeiroPF(ctx) {
    return ctx.configuracao.solFatPFEstrangeiro && ctx.usuario.permissoes.solFaturamento;
  },
  solFaturamentoEstrangeiroPJ(ctx) {
    return ctx.configuracao.solFatPJEstrangeiro && ctx.usuario.permissoes.solFaturamento;
  },
  solReembolsoTerceiro(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.solReembolsoTerceiro && ctx.usuario.permissoes.solReembolsoTerceiro;
  },
  solReembolsoAtividade(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.habilitarPrestacaoContasReembolso && ctx.usuario.permissoes.solReembolsoAtividade;
  },
  prestacaoContasPessoaFisica(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisica && ctx.configuracao.habilitarPrestacaoContasReembolso;
  },
  solAdiantamento(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.solAdiantamento && ctx.usuario.permissoes.solAdiantamento;
  },
  solBolsa(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.solBolsa && ctx.usuario.permissoes.solBolsa;
  },
  solBolsaAtividade(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.liberarAtividadeContrato;
  },
  acompanhamentoProjeto(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.acompanhamentoProjeto;
  },
  relatorioTecnicoProjeto(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.relatorioTecnicoProjeto;
  },
  solCursoEventoServico(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solCursoEventoServico;
  },
  solTransferencia(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solTransferencia;
  },
  solCancelamentoContrato(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solCancelamentoContrato;
  },
  solContratacaoPessoal(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solContratacaoPessoal;
  },
  usuarioLiberarCompras(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.usuario.permissoes.usuarioLiberarCompras;
  },
  usuarioLiberarContratos(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.usuario.permissoes.usuarioLiberarContratos && ctx.configuracao.utilizarLiberacaoContratoNiveis;
  },
  utilizarLiberacaoContrato(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.configuracao.utilizarLiberacaoContratoNiveis;
  },
  pedidoCompra(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ((ctx.usuario.permissoes.solCompras && ctx.fusp) || ctx.configuracao.utilizarLiberacaoPedidoCoordenador);
  },
  liberarProvisoesPagamento(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.liberarProvisoesPagamento;
  },
  liberarPagamento(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.liberarPagamento;
  },
  solImportacao(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Importacao;
  },
  solImportacaoProjetos(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && ctx.usuario.permissoes.solImportacao;
  },
  relatorios(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Coordenador && (
      (ctx.configuracao.relLancamentoAplicacao && ctx.usuario.permissoes.relLancamentoAplicacao) ||
      (ctx.configuracao.relProtocolos && ctx.usuario.permissoes.relProtocolos) ||
      (ctx.configuracao.relRubrica && ctx.usuario.permissoes.relRubrica) ||
      (ctx.configuracao.relSubrubrica && ctx.usuario.permissoes.relSubrubrica) ||
      (ctx.configuracao.relImpostosPorProjeto && ctx.usuario.permissoes.relImpostosPorProjeto) ||
      (ctx.configuracao.relVerificacaoLancamento && ctx.usuario.permissoes.relVerificacaoLancamento) ||
      (ctx.configuracao.relLancamentoFinanceiro && ctx.usuario.permissoes.relLancamentoFinanceiro) ||
      (ctx.configuracao.relLancamentoFinanceiroResumo && ctx.usuario.permissoes.relLancamentoFinanceiroResumo) ||
      (ctx.configuracao.relLancamentoFinanceiroProjeto && ctx.usuario.permissoes.relLancamentoFinanceiroProjeto) ||
      (ctx.configuracao.relLancamentoCambio && ctx.usuario.permissoes.relLancamentoCambio) ||
      (ctx.configuracao.relPedidoCompra && ctx.usuario.permissoes.relPedidoCompra) ||
      (ctx.configuracao.relMensalidadeAluno && ctx.usuario.permissoes.relMensalidadeAluno) ||
      (ctx.configuracao.relContasPagarReceber && ctx.usuario.permissoes.relContasPagarReceber) ||
      (ctx.configuracao.relSaldos && ctx.usuario.permissoes.relSaldos) ||
      (ctx.usuario.permissoes.relControleItem) ||
      (ctx.configuracao.relProvisao && ctx.usuario.permissoes.relProvisao)
    );
  },
  relatoriosAcessoEspecial(ctx) {
    if (ctx.usuario.acessoEspecialPermissoes == null)
      return false;

    return ctx.usuario.tipoUsuario === tipoUsuario.AcessoEspecial && (
      (ctx.usuario.acessoEspecialPermissoes.relRubrica) ||
      (ctx.usuario.acessoEspecialPermissoes.relControleItem) ||
      (ctx.usuario.acessoEspecialPermissoes.relLancamentoFinanceiro)
    );
  },
  relLancamentoAplicacao(ctx) {
    return ctx.configuracao.relLancamentoAplicacao && ctx.usuario.permissoes.relLancamentoAplicacao;
  },
  relProtocolos(ctx) {
    return ctx.configuracao.relProtocolos && ctx.usuario.permissoes.relProtocolos;
  },
  relRubrica(ctx) {
    return ctx.configuracao.relRubrica && ctx.usuario.permissoes.relRubrica;
  },
  relControleItem(ctx) {
    return ctx.usuario.permissoes.relControleItem;
  },
  relSubrubrica(ctx) {
    return ctx.configuracao.relSubrubrica && ctx.usuario.permissoes.relSubrubrica;
  },
  relImpostosPorProjeto(ctx) {
    return ctx.configuracao.relImpostosPorProjeto && ctx.usuario.permissoes.relImpostosPorProjeto;
  },
  relVerificacaoLancamento(ctx) {
    return ctx.configuracao.relVerificacaoLancamento && ctx.usuario.permissoes.relVerificacaoLancamento;
  },
  relLancamentoFinanceiro(ctx) {
    return ctx.configuracao.relLancamentoFinanceiro && ctx.usuario.permissoes.relLancamentoFinanceiro;
  },
  relLancamentoFinanceiroResumo(ctx) {
    return ctx.configuracao.relLancamentoFinanceiroResumo && ctx.usuario.permissoes.relLancamentoFinanceiroResumo;
  },
  relLancamentoFinanceiroProjeto(ctx) {
    return ctx.configuracao.relLancamentoFinanceiroProjeto && ctx.usuario.permissoes.relLancamentoFinanceiroProjeto;
  },
  relLancamentoCambio(ctx) {
    return ctx.configuracao.relLancamentoCambio && ctx.usuario.permissoes.relLancamentoCambio;
  },
  relPedidoCompra(ctx) {
    return ctx.configuracao.relPedidoCompra && ctx.usuario.permissoes.relPedidoCompra;
  },
  relMensalidadeAluno(ctx) {
    return ctx.configuracao.relMensalidadeAluno && ctx.usuario.permissoes.relMensalidadeAluno;
  },
  relContasPagarReceber(ctx) {
    return ctx.configuracao.relContasPagarReceber && ctx.usuario.permissoes.relContasPagarReceber;
  },
  relSaldos(ctx) {
    return ctx.configuracao.relSaldos && ctx.usuario.permissoes.relSaldos;
  },
  relProvisoes(ctx) {
    return ctx.configuracao.relProvisao && ctx.usuario.permissoes.relProvisao;
  },
  relatoriosFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && (
      (ctx.configuracao.relLancamentoAplicacao) ||
      (ctx.configuracao.relProtocolos) ||
      (ctx.configuracao.relRubrica) ||
      (ctx.configuracao.relSubrubrica) ||
      //(ctx.configuracao.relImpostosPorProjeto && ctx.usuario.permissoes.relImpostosPorProjeto) ||
      //(ctx.configuracao.relVerificacaoLancamento && ctx.usuario.permissoes.relVerificacaoLancamento) ||
      (ctx.configuracao.relLancamentoFinanceiro) ||
      //(ctx.configuracao.relLancamentoFinanceiroResumo && ctx.usuario.permissoes.relLancamentoFinanceiroResumo) ||
      //(ctx.configuracao.relLancamentoFinanceiroProjeto && ctx.usuario.permissoes.relLancamentoFinanceiroProjeto) ||
      //(ctx.configuracao.relLancamentoCambio && ctx.usuario.permissoes.relLancamentoCambio) ||
      //(ctx.configuracao.relPedidoCompra && ctx.usuario.permissoes.relPedidoCompra) ||
      //(ctx.configuracao.relMensalidadeAluno && ctx.usuario.permissoes.relMensalidadeAluno) ||
      (ctx.configuracao.relContasPagarReceber)
      //(ctx.configuracao.relSaldos && ctx.usuario.permissoes.relSaldos) ||
      //(ctx.usuario.permissoes.relControleItem) ||
      //(ctx.configuracao.relProvisao && ctx.usuario.permissoes.relProvisao)
    );
  },
  
  relLancamentoAplicacaoFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relLancamentoAplicacao;
  },
  relProtocolosFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relProtocolos;
  },
  relRubricaFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relRubrica;
  },
  relSubrubricaFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relSubrubrica;
  },
  //relImpostosPorProjetoFuncionario() {
  //  return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relImpostosPorProjeto;
  //},
  //relVerificacaoLancamentoFuncionario() {
  //  return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relVerificacaoLancamento;
  //},
  relLancamentoFinanceiroFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relLancamentoFinanceiro;
  },
  relContasPagarReceberFuncionario(ctx) {
    return ctx.usuario.tipoUsuario === tipoUsuario.Funcionario && ctx.configuracao.relContasPagarReceber;
  },

  rotaSolicitacaoPF(ctx) {
    return 'solicitacao-pagamento-pf';
  },
  rotaSolicitacaoPJ(ctx) {
    return 'solicitacao-pagamento-pj';
  },
  rotaSolicitacaoEstrangeiroPF(ctx) {
    return 'solicitacao-pagamento-estrangeiro-pf';
  },
  rotaSolicitacaoEstrangeiroPJ(ctx) {
    return 'solicitacao-pagamento-estrangeiro-pj';
  },
  rotaRelatorioFinanceiro(ctx) {
    return ctx.configuracao.relatExtratoProjetoModelo == 3 ? 'relatorio.lancamentos-modelo3' : 'relatorio.lancamentos';
  },
  fusp(ctx) {
    return ctx.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
  },
  rotaSolicitacaoPFRateio(ctx) {
    return 'solicitacao-pagamento-rateio-pf';
  },
  rotaSolicitacaoPJRateio(ctx) {
    return 'solicitacao-pagamento-rateio-pj';
  },
  habilitarAssinaturaEletronica(ctx) {
    return ctx.configuracao.habilitarAssinaturaEletronica;
  },
};

export function criarContextoAcesso(usuario, configuracao) {
  const ctx = {
    usuario: Object.assign({}, usuario, {
      permissoes: (usuario && usuario.permissoes) || {},
      acessoEspecialPermissoes: (usuario && usuario.acessoEspecialPermissoes) || null,
    }),
    configuracao: Object.assign({ abreviaturaFundacao: '' }, configuracao),
  };

  Object.keys(regras).forEach(nome => {
    Object.defineProperty(ctx, nome, {
      enumerable: true,
      get() {
        return regras[nome](ctx);
      },
    });
  });

  return ctx;
}

export function computedsDeAcesso() {
  const computeds = {};

  Object.keys(regras).forEach(nome => {
    computeds[nome] = function () {
      return regras[nome](this);
    };
  });

  return computeds;
}

export default regras;



// WEBPACK FOOTER //
// ./FrontEnd/js/acessos.js